/**
 * CJdropshipping vs Dayone 子页面入口
 * 路由：/cjdropshipping-vs-day-one-fulfillment
 * pageName：alternatives/cjVsDayone
 *
 * 页面结构（复用公共模板 + 公共组件）：
 *   VsHero            — 子页 Banner（来自 vsPageTemplate.jsx）
 *   SellpointsBar     — 卖点标签横排（公共）
 *   VsComparisonTable — 三列对比表（来自 vsPageTemplate.jsx）
 *   FitSection        — Who Should Choose（公共）
 *   AdvantagesSection — 核心优势 8 卡片（公共）
 *   TestimonialSection — 双行跑马灯（公共）
 *   VsFaqSection      — 子页专属 FAQ，左摘要卡片 + accordion（来自 vsPageTemplate.jsx）
 *   BottomCta         — 底部 CTA（公共）
 *
 * 【注意】
 * - 遵循 odm/index.jsx 模式：CdnHostContext + ConstantsContext 在根组件 provide
 * - getDayoneConstants(cdnHost) 通过 useMemo 缓存，避免每次渲染重新创建
 * - withSSR HOC 包装导出
 */

import React, { useCallback, useMemo, useState } from 'react';
import withSSR from '../../../hoc/withSSR';
import fetchData from './fetch';
import styles from './index.less';
import { getDayoneConstants } from './constants';
import {
  CdnHostContext,
  ConstantsContext,
  handleCtaClick,
  SellpointsBar,
  FitSection,
  AdvantagesSection,
  TestimonialSection,
  BottomCta,
} from '../shared/SharedComponents';
import {
  VsHero,
  VsComparisonTable,
  VsFaqSection,
} from '../shared/vsPageTemplate';

/**
 * CJ vs Dayone 子页面入口
 * 通过 ConstantsContext.Provider 向子组件注入 Dayone 专属文案
 */
function CjVsDayonePage(props) {
  const pageData = props.pageData || {};
  const cdnHost = pageData.cdnHost || (typeof CDN_HOST !== 'undefined' ? CDN_HOST : '');
  const constants = useMemo(function () {
    return getDayoneConstants(cdnHost);
  }, [cdnHost]);

  const [showModal, setShowModal] = useState(false);

  const onCtaClick = useCallback(function (url) {
    handleCtaClick(url, setShowModal);
  }, []);

  return (
    <CdnHostContext.Provider value={cdnHost}>
      <ConstantsContext.Provider value={constants}>
        <div className={styles['vs-page'] + ' ' + styles['page-root']}>
          <VsHero styles={styles} onCtaClick={onCtaClick} />
          <SellpointsBar styles={styles} />
          <VsComparisonTable styles={styles} />
          <FitSection styles={styles} />
          <AdvantagesSection styles={styles} onCtaClick={onCtaClick} />
          <TestimonialSection styles={styles} />
          <VsFaqSection styles={styles} onCtaClick={onCtaClick} />
          <BottomCta styles={styles} onCtaClick={onCtaClick} />
        </div>
      </ConstantsContext.Provider>
    </CdnHostContext.Provider>
  );
}

CjVsDayonePage.fetch = fetchData;

export default withSSR(CjVsDayonePage);
